/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 3000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Petal Chain",
  title: "Hi, I am Petal",
  subTitle_1: emoji(
    "Experienced senior blockchain developer proficient in Ethereum, Hyperledger Fabric, and Solidity, with expertise in Truffle, Ganache, and Remix. I deliver secure and innovative blockchain solutions.🏆"
  ),
  subTitle_2: emoji(
    "🌸 I deliver secure and innovative blockchain solutions.🌸 "
  ),
  resumeLink:
    "https://drive.google.com/file/d/1KnMEtje-h3ZOUY4B1MA4yFJgFbqhC_EJ/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/PetalChain",
  gmail: "worldsmileswithyou@gmail.com",
  telegram: "https://t.me/petalch",
  skype: "https://join.spe.com/invite/Hzwb9WzLLjVA",
  discord: "https://discord.gg/u/petalchain",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Skilled and Experienced Blockchain Developer delivering high-quality solutions",
  skills: [
    emoji(
      "👉 Develop 💸digital currency💸 based on various blockchain networks like Ethereum, Binace Smart Chain and more."
    ),
    emoji("👉 Develop 💎digital assets💎 ensuring unequivocal proof of ownership and authenticity."),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Contract",
      srcPath: "1.png"
    },
    {
      skillName: "Currency",
      srcPath: "3.png"
    },
    {
      skillName: "NFT",
      srcPath: "10.png"
    },
    {
      skillName: "DApp",
      srcPath: "4.png"
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Blockchain Training Alliance",
      logo: require("./assets/images/BAT.png"),
      duration: "2019",
      descBullets: [
        "Certified Blockchain Developer - Ethereum (CBDE)",
        "Certified Blockchain Project Manager (CBPM)",
        "Understanding CryptoCurrency Online Course",
        "NFT Foundations Online Course"
      ]
    },
    {
      schoolName: "University of Tokyo",
      logo: require("./assets/images/TokyoLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "2014-2018",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Block Chain, Web Security, ...",

    }

  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Crypto Currency", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "NFT Token",
      progressPercentage: "80%"
    },
    {
      Stack: "Web3",
      progressPercentage: "85%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Blockchain Developer",
      company: "BrightNode",
      companylogo: require("./assets/images/BrightNode.png"),
      date: "Jan 2020 – Nov 2023",
      descBullets: [
        "Designed and developed smart contracts for various clients using Solidity on Ethereum blockchain, ensuring secure and efficient execution of business logic.",
        "Collaborated with clients to identify their requirements and translate them into technical specifications, ensuring that the solutions met their needs.",
        "Developed custom APIs to integrate smart contracts with external systems enabling seamless data exchange and interoperability.",
      ]
    },
    {
      role: "Blockchain Developer",
      company: "4IRE",
      companylogo: require("./assets/images/4IRE.png"),
      date: "Feb 2018 – Dec 2019",
      descBullets: [
        "Developed decentralized applications (DApps) using solidity and JavaScript on Ethereum blockchain, contributing to the growth of the blockchain ecosystem by creating user-friendly and intuitive interfaces.",
        "Implemented smart contracts for tokenization of assets and peer-to-peer lending, ensuring compliance with industry standards and best practices.",
        "Conducted code reviews and implemented best practices such as unit testing and code documentation, ensuring high-quality deliverables."
      ]    
    },

  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "Some Crypto Currency tokens that I helped to create.",
  projects: [
    {
      image: require("./assets/images/source.png"),
      projectName: "Source Token",
      projectDesc: "Participated in developing Source token contract as a blockchain developer.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.sourceprotocol.io/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/BlueMove.png"),
      projectName: "Blue Move",
      projectDesc: "Participated in developing swap contract for AMM DEX on BlockChain.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://dex.bluemove.net/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/pathDAO.png"),
      projectName: "pathDAO",
      projectDesc: "Created pathDAO token contract from scratch.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.pathdao.io/"
        }
        //  you can add extra buttons here.
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji(" 🏆 Certifications 🏆 "),
  subtitle:
    "Certifications that I got !",

  achievementsCards: [
    {
      title: "CBDE",
      subtitle:
        "Certified BlockChain Developer Ethereum",
      image: require("./assets/images/CBDE.png"),
      imageAlt: "CBDE Logo",
      footerLink: [
      ]
    },
    {
      title: "CBPM",
      subtitle:
        "Certified BlockChain Project Manager",
      image: require("./assets/images/cbpm.png"),
      imageAlt: "CBDE Logo",
      footerLink: [
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-0000000000",
  email_address: "saadpasta70@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
